export default __webpack_public_path__ + "static/media/404-left.51cd9396.svg";